//<template>
	<div class="p-grid">
		<div class="p-col-12">
			<div class="card">
        <Toolbar class="p-mb-4 p-p-2">
          <template #start>
            <div style="font-size: 1.4em; color: inherit" class="p-p-2">{{ $t('Login History') }}</div>
          </template>
          <template #end>
            <SearchInput :disabled="dataTableIsLoading" @change-processed-search-value="changeProcessedSearchValue" v-model="searchData" @show-spinner="isLoading = true"/>
          </template>
        </Toolbar>

        <!--  Desktop DataTable -->
        <Spinner v-if="isLoading"/>
<!--        <DesktopDataTable v-else-if="!isLoading && !$store.state.tabletLayout"-->
        <DesktopDataTable v-else
                          :dataTableIsLoading="dataTableIsLoading"
                          :showHeader="false"
                          :itemsArrayIsEmpty="itemsArrayIsEmpty"
                          :sort="sort"
                          :showButtons="!!actionButtonsCount"
                          :showSearchInput="false"
                          :actionButtonsCount="actionButtonsCount"
                          @sort-items="sortItems"
                          :headers="[
                              {name: 'created_at', title: $t('Created'), sortable: true},
                              {name: 'type', title: $t('Type'), sortable: false},
                              {name: 'is_success', title: $t('Status'), sortable: false},
                              {name: 'attempted_login', title: $t('Username'), sortable: false},
                              {name: 'user', title: $t('User'), sortable: false},
                              {name: 'tenant', title: $t('Tenant'), sortable: false},
                              {name: 'ip', title: 'IP',sortable: false},
                              // {name: 'country', title: $t('Country'), sortable: false},
                              {name: 'user_agent', title: $t('User-Agent'), sortable: false},
                               {name: 'reason', title: $t('Reason'), sortable: false},
                              {name: 'details', title: 'Details', sortable: false},
          ]">
          <template v-slot:body>
            <tr v-for="(item, index) of items"
                :key="index"
                :class="{'updated-item': isItemUpdated(item.id)}">
              <td>
                {{ formatDate(item.created_at, true) }}
              </td>
              <td>
                <span v-if="item.type === 1">In</span>
                <span v-else-if="item.type === 2">Out</span>
                <span v-else-if="item.type === 3">Token refresh</span>
                <i v-else class="ti-minus"/>
<!--                <span class="pi pi-sign-in" v-if="item.type === 1"/>-->
<!--                <span class="pi pi-sign-out" v-if="item.type === 2"/>-->
              </td>
              <td>
                <i class="pi pi-check green-color" v-if="item.is_success"/>
                <i class="pi pi-times warning-color" v-else/>
              </td>
              <td>
<!--                <span v-if="item.attempted_login">{{ maskAttemptedLogin(item.attempted_login) }}</span>-->
                <span v-if="item.attempted_login">{{ item.attempted_login }}</span>
                <i v-else class="ti-minus"/>
              </td>
              <td>
                <span v-if="item.user">{{ item.user.first_name }} {{ item.user.last_name }}</span>
                <i v-else class="ti-minus"/>
              </td>
              <td>
                <span v-if="item.tenant_name">{{ item.tenant_name }}</span>
                <i v-else class="ti-minus"/>
              </td>
              <td>
<!--                <span v-if="item.ip">{{ maskIp(item.ip) }}</span>-->
                <span v-if="item.ip">{{ item.ip }}</span>
                <i v-else class="ti-minus"/>
              </td>

<!--              <td>-->
<!--                <div v-if="item.country_name || item.city">-->
<!--                  <div>{{ item.country_name || '-' }}</div>-->
<!--                  <small v-if="item.city">{{ item.city }}</small>-->
<!--                </div>-->
<!--                <i v-else class="ti-minus"></i>-->
<!--              </td>-->

              <td>
                <div v-if="item.user_agent" style="min-width: 240px">{{ item.user_agent }}</div>
                <i v-else class="ti-minus"/>
              </td>
              <td>
                <div v-if="item.reason">{{ item.reason }}</div>
                <i v-else class="ti-minus"/>
              </td>
              <td>
                <div v-if="item.details">{{ item.details }}</div>
                <i v-else class="ti-minus"/>
              </td>
            </tr>
          </template>
        </DesktopDataTable>

        <OwnPaginator v-show="!itemsArrayIsEmpty"
                      :rows="pagination.perPage"
                      :currentPage="pagination.currentPage - 1"
                      :totalPages="pagination.pageCount"
                      :totalRecords="pagination.totalCount"
                      :rowsPerPageOptions="[5,10,25,50,100,200]"
                      :pageLinkSize="11">
        </OwnPaginator>

        <TotalRecordsData :pagination="pagination" :itemsArrayIsEmpty="itemsArrayIsEmpty"/>
			</div>
		</div>
	</div>
</template>

<script>
import httpClient from '@/services/http.services'
import formatMixins from "@/mixins/formatMixins";
import datatableMixins from "@/mixins/datatableMixins";
import settings from "@/settings";
import showErrorsMixins from "@/mixins/showErrorsMixins";
// import {maskAttemptedLogin, maskIp} from "@/utils/mask";

export default {
  mixins: [ formatMixins, datatableMixins, showErrorsMixins ],
	data() {
		return {
      fieldsExpand: 'user,tenant_name',
      apiLink: 'auth-log',
      routePath: '/login-history',
      searchData: '',
      sort: {
        column: 'created_at',
        direction: '-',
      },
		}
	},
  mounted() {
    this.scrollToTop()
    if (settings.autoLogoutTimeout && this.$store.state.logoutTimestampIsOverdue) return false
    this.checkRouteQuery()
    // if (!this.$store.state.user?.role) return
    // this.getItems()
    this.getPageData()
	},
  methods: {
    formatIpLocation(item) {
      if (item.ip === '::1' || item.ip === '127.0.0.1') return 'Localhost'

      const parts = [item.country_name, item.city].filter(Boolean)
      return parts.length ? parts.join(', ') : ''
    },
    getPageData() {
      // if (!this.userCanGetData || this.fetchInFlight) return
      this.getItems()
    },
    // maskAttemptedLogin, maskIp,
    async getItems() {
      // if (!this.$store.getters.isUserReady) return
      if (!this.userCanGetData || this.fetchInFlight) return
      this.$store.commit('SET_FETCH_IN_FLIGHT', true)
      this.dataTableIsLoading = true
      const ctrl = this.setController?.('loginHistory')
      try {
        const { status, data, headers } = await httpClient({
          url: this.apiLink,
          params: {
            // type: this.selectedTypeId,
            page: this.pagination.currentPage,
            'per-page': this.pagination.perPage,
            sort: this.sort.direction + this.sort.column,
            search: this.searchData,
            expand: this.fieldsExpand,
          },
          signal: ctrl?.signal
        })
        if (status === 200 && data && Array.isArray(data)) {
          const hasPaginationHeaders = !!headers['x-pagination-total-count']
          if (hasPaginationHeaders) {
            this.pagination.totalCount = +headers['x-pagination-total-count']
            this.pagination.pageCount  = +headers['x-pagination-page-count']
          } else {
            this.pagination.totalCount = data.length
            this.pagination.pageCount  = 1
          }

          this.items = data

          if (!data.length) {
            this.pagination.pageCount = 1
            this.pagination.currentPage = 1
          }
        } else {
          this.showUnknownError()
        }
      } catch(err) {
        this.showError(err)
      } finally {
        this.$store.commit('SET_FETCH_IN_FLIGHT', false)
        this.dataTableIsLoading = false
        this.isLoading = false
        if (this._abortors?.loginHistory === ctrl) {
          this._abortors.loginHistory = null
        }
      }
    },
	},
  computed: {
    actionButtonsCount() {
      return 0
    },
  }
}
</script>

<style scoped lang="scss">

</style>